module.exports = __webpack_public_path__ + "h5/img/live-logo.946f7bba.gif";